import { useMutation, useQueryClient } from "@tanstack/react-query";
import { FetchError } from "../../../types";
import { configuration } from "../../../../configuration";
import { useAccessToken } from "../../../use-access-token";
import { queryKeys } from "../../queryKeys";
import { useSignalR } from "../../../../hooks";

type Variables = {
  agendaStepGuid: string;
};

const useUnlockAgendaItemTextContentRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function unlockAgendaItemTextContentRequest(variables: Variables): Promise<void> {
    const accessToken = await getAccessToken();

    const response = await fetch(
      `${configuration.apiRootUrl}/agenda-items/${variables.agendaStepGuid}/text-content/unlock`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        method: "put",
      }
    );

    if (!response.ok) {
      throw new FetchError(response);
    }
  }

  return { unlockAgendaItemTextContentRequest };
};

const useUnlockAgendaItemTextContent = () => {
  const { unlockAgendaItemTextContentRequest } = useUnlockAgendaItemTextContentRequest();
  const queryClient = useQueryClient();
  const signalR = useSignalR();

  return useMutation({
    mutationFn: unlockAgendaItemTextContentRequest,
    onSuccess: (_data, variables) => {
      signalR.sendRefetchAgendaItemContent(variables.agendaStepGuid);
    },
    onSettled: (_data, _error, variables) => {
      queryClient.invalidateQueries(queryKeys.meetings.getAgendaItemTextContent(variables.agendaStepGuid));
    },
  });
};

export { useUnlockAgendaItemTextContent };
